import UploadFileButton from "./uploadFileButton.jsx";

export default UploadFileButton;



// WEBPACK FOOTER //
// ./src/components/common/buttons/uploadFileButton/index.js